import React from "react";
import { motion } from "framer-motion";
import { Smartphone } from "lucide-react";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { fadeUp, staggerContainer, viewport } from "../../lib/motion";

const CARDS = [
  { title: "Celular", description: "Problemas de tela, bateria, carregamento e outros." },
  { title: "Tablet", description: "Conte o que aconteceu e veja como podemos ajudar." },
  { title: "Dispositivos Apple", description: "iPhone, iPad, Mac, Apple Watch e AirPods." },
  { title: "Outros aparelhos", description: "Se não encontrou o seu aparelho, fale com a gente." },
];

export const DeviceCategories = () => {
  return (
    <section
      data-testid="device-categories-section"
      className="relative bg-[#050505] py-28 md:py-40 border-t border-white/[0.05]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="text-center max-w-2xl mx-auto"
        >
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-[#f5f5f7]">
            Cada aparelho tem sua história.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#86868b]">
            Conte o que aconteceu. A Inove Tech avalia o seu caso.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6"
        >
          {CARDS.map((card, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              data-testid={`device-card-${i + 1}`}
              className="bento-card bg-[#1a1a1a] border border-white/[0.05] rounded-[28px] p-8 min-h-[240px] flex flex-col"
            >
              <div className="w-12 h-12 rounded-2xl bg-white/[0.04] border border-white/[0.06] flex items-center justify-center mb-8">
                <Smartphone size={22} className="text-[#f5f5f7]" strokeWidth={1.8} />
              </div>
              <h3 className="text-xl md:text-2xl font-bold tracking-tight text-[#f5f5f7]">
                {card.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#86868b]">
                {card.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-14 flex justify-center">
          <WhatsAppCTA label="Falar no WhatsApp" testId="device-whatsapp" />
        </div>
      </div>
    </section>
  );
};
